<template>
  <section
    class="h-100 cursor-pointer">
    <coozzy-card
      class="mb-0 inherit-height"
      @click="openSelectedReport">
      <div class="row">
        <div class="col-2 text-center">
          <img
            v-if="keyReport"
            :src="require(`@/assets/icon/reportIcons/${keyReport}.svg`)"
            :alt="keyReport"
            width="50"
            height="50">
        </div>
        <div class="col-10">
          <template
            v-if="keyReport !== 'defaultReport'">
            <h5>
              {{ $t(`message.navigation.reporting.types.${keyReport}.title`) }}
            </h5>
            <p>
              {{ $t(`message.navigation.reporting.types.${keyReport}.description`) }}
            </p>
            <ul class="pl-2">
              <li>
                <span><b>KPIs</b>: {{ $t(`message.navigation.reporting.types.${keyReport}.kpis`) }} </span>
              </li>
            </ul>
          </template>
          <template v-else>
            <h5>
              {{ report.title }}
            </h5>
            <div
              v-if="report.subTitle"
              v-dompurify-html="report.subTitle" />
            <ul class="pl-2">
              <li>
                <span><b>KPIs</b>: - </span>
              </li>
            </ul>
          </template>
        </div>
      </div>
    </coozzy-card>
  </section>
</template>

<script lang="ts">
import CoozzyCard from '@/framework/components/card/CoozzyCard.vue'
import Vue, { PropType } from 'vue'
import { ReportingReportingUrl } from '@/types/api'

export default Vue.extend({
  name: 'ReportCard',
  components: { CoozzyCard },
  mixins: [],
  props: {
    report: {
      type: Object as PropType<ReportingReportingUrl>,
      required: true
    }
  },
  data() {
    return {
      availableReportsTypes: [
        {
          possibleNames: ['Revenue Overview', 'Umsatzübersicht', 'Panoramica dei ricavi'],
          key: 'revenueOverview'
        },
        {
          possibleNames: ['Occupancy Register', 'Belegungsverzeichnis', 'Registro di occupazione'],
          key: 'occupancyRegister'
        },
        {
          possibleNames: ['Marketing History', 'Vermarktung Historie', 'Cronologia della commercializzazione'],
          key: 'marketingHistory'
        },
        {
          possibleNames: ['Debtor Open Items', 'Debitoren Offene Posten', 'Debitori – Partite aperte'],
          key: 'debtorOpenItems'
        },
        {
          possibleNames: ['Debtor Revenue', 'Debitoren Umsatz', 'Debitori – Ricavi'],
          key: 'debtorRevenue'
        },
        {
          possibleNames: ['Creditor Open Items', 'Kreditoren Offene Posten', 'Creditori – Partite aperte'],
          key: 'creditorOpenItems'
        },
        {
          possibleNames: ['Creditor Expenses', 'Kreditoren Umsatz', 'Creditori – Spese'],
          key: 'creditorExpenses'
        },
        {
          possibleNames: ['Mortgage Analysis', 'Hypotheken Auswertung', 'Analisi ipoteche'],
          key: 'mortgageAnalysis'
        },
        {
          possibleNames: ['Condition Analysis', 'Zustandsanalyse', 'Analisi dello stato'],
          key: 'conditionAnalysis'
        },
        {
          possibleNames: ['Investment Plan', 'Investitionsplan', 'Piano investimenti'],
          key: 'investmentPlan'
        },
        {
          possibleNames: ['Insurance Overview', 'Versicherungsübersicht', 'Panoramica assicurazioni'],
          key: 'insuranceOverview'
        },
        {
          possibleNames: ['Budget report', 'Budget Report', 'Rapporto sul bilancio'],
          key: 'budgetReport'
        },
        {
          possibleNames: ['Parzellenübersicht', 'Land Register Overview', 'Panoramica del catasto'],
          key: 'landRegisterOverview'
        },
        {
          possibleNames: [
            'Wartungsübersicht', 'Maintenance Overview', 'Panoramica manutenzione'
          ],
          key: 'maintenanceOverview'
        },
        {
          possibleNames: ['Leerstand Report', 'Vacancy Report', 'Report Sfitto'],
          key: 'vacancyReport'
        },
        {
          possibleNames: ['Aktivitätenauswertung', 'Activity Analysis', 'Analisi delle attività'],
          key: 'activityAnalysis'
        }
      ],
      keyReport: 'defaultReport'
    }
  },
  mounted() {
    if (this.report && this.report.title) {
      const item = this.availableReportsTypes.find((reportType) => {
        return reportType.possibleNames.includes(this.report.title)
      })
      this.keyReport = item ? item.key : 'defaultReport'
    }
  },
  methods: {
    openSelectedReport() {
      this.$emit('open-selected-report', this.report)
    }
  }
})
</script>

<style lang="scss" scoped>
.inherit-height {
  height: inherit;
}
</style>
